import { OpeningHours } from './Provider.model';

export type ImageType = {
  imageUrl: string;
  imageOriginalUrl?: string;
  order?: number;
};

export type WelcomePackageSettings = {
  receiverName: string;
  companyName?: string;
  street: string;
  zipCode: string;
  city: string;
  country: string;
  a5FlyerAmount?: number;
  a6FlyerAmount?: number;
};

export interface ILocationEdit {
  uuid: string;
  id?: string;
  name: string;
  description: string;
  mappingStatus?: MappingStatus;
  zipCode: string;
  city: string;
  street: string;
  countryISOA2: string;
  latitude: number;
  longitude: number;
  detailsUrl: string;
  howToFind: string;
  imageUrl: string;
  archived?: boolean;
  suspended?: boolean;
  inUse?: boolean;
  color: string;
  onlineBookingsDisabled: boolean;
  email?: string;
  images?: ImageType[];
  phone?: string;
  website: string | null;
  importantInformation?: string;
  openingHours?: OpeningHours;
  replacementLocationId?: string;
  welcomePackageSettings?: WelcomePackageSettings;
  organisationVenueId?: number;
  venueAddressId?: number;
  checkInUrl?: string;
  merchant?: string;
  liveStreamEnabled?: boolean;
  state?: string;
  profileUrl?: string;
  defaultCancellationWindow: '' | number | null;
  firstFreeCheckin: boolean;
  latitudeMap?: number;
  longitudeMap?: number;
}

export interface ILocation extends ILocationEdit {
  uuid: string;
  id: string;
  mappingStatus: MappingStatus;
  archived: boolean;
  suspended: boolean;
  inUse: boolean;
  providerId?: string;
}

export enum MappingStatus {
  Unmapped = 'UnMapped', //Obsolete with https://fitogram.atlassian.net/browse/CS-267
  InProcess = 'InProcess', //Obsolete with https://fitogram.atlassian.net/browse/CS-267
  UnderReview = 'UnderReview', //Replaces InProcess with https://fitogram.atlassian.net/browse/CS-267
  Mapped = 'Mapped',
}

export interface IDefaultCancellationWindow {
  defaultCancellationWindow: number;
  locationId: string;
}
